module.exports = __webpack_public_path__ + "static/pie_chart_animation-ad7ef9966c1595c7b8776cf1de926b0c.mp4";